module.exports = __webpack_public_path__ + "static/EssentialIndustry-af0d060671ed1a90cfc6691c8cfb01aa.png";